import { useIntl } from "@leagueplatform/locales";
import APPLE_BADGE from "assets/apple-store-badge.svg";
import { EXTERNAL_URLS } from "common/urls";
import { StoreLink } from "./store-link.component";

// Apple's brand guidelines require the badge in English regardless of UI
// locale. Localized PNGs in assets/apple-store/ kept for safety; delete that
// directory if/when product confirms the English-only badge is acceptable.
export const AppleStoreLink = () => {
  const { formatMessage } = useIntl();

  return (
    <StoreLink
      href={EXTERNAL_URLS.APPLE_STORE_APP}
      src={APPLE_BADGE}
      alt={formatMessage({ id: "STR_DOWNLOAD_APP_STORE" })}
      css={{ width: "158px", height: "52px" }}
    />
  );
};
